module.exports = __webpack_public_path__ + "media/images/cleaning/karima@2x-123cb2f0be0614d356dd148eca7285c1.jpg";